import React from 'react';

import { BrandIcon } from '../brand-icon';
import { SystemIcon } from '../system-icon';
import * as styles from './icon-list.module.css';

interface IconListProps {
	iconColor: string;
	iconStyle: string;
	iconSize: string;
	icons: any[];
	liStyle: string;
}

export function IconList({
	iconColor,
	iconStyle,
	iconSize,
	icons,
	liStyle,
}: IconListProps) {
	return (
		<ul className={styles.iconList}>
			{icons?.map((icon) => {
				const { _key } = icon;
				const iconType = icon?.icon?._type;

				return (
					<li key={_key} className={styles.iconContainer}>
						{iconType === 'brandIcon' && (
							<BrandIcon
								icon={icon}
								iconListColor={iconColor}
								iconListStyle={iconStyle}
								iconListSize={iconSize}
							/>
						)}
						{iconType === 'systemIcon' && (
							<SystemIcon
								icon={icon?.icon}
								iconColor={iconColor}
								iconSize={iconSize}
							/>
						)}
						<div className={styles.iconText}>
							<p className={liStyle}>{icon?.iconTitle}</p>
							<p className='body-s cdgr'>
								{icon?.iconDescription}
							</p>
						</div>
					</li>
				);
			})}
		</ul>
	);
}
